'use strict';

/* We need to tell jshint about global variables */
/* global toastr: false
 */

angular.module('atex.dam').factory('DamNotificationService', ['$rootScope', '$q', '$modal',

function($rootScope, $q, $modal) {

  /**
   * The internal list of notifications. Note that these
   * are only kept in-memory, and not persisted.
   */
  var _notificationLog = [];

  /**
   * Initialize the Toastr library.
   */
  (function(t) {
    t.options.positionClass = "toast-bottom-right";

    t.options.showDuration = 100;
    t.options.showMethod = "fadeIn";

    t.options.hideDuration = 300;
    t.options.hideMethod = "fadeOut";

    /**
     * The default onclick action will display the Notification Center.
     */

    t.options.onclick = function() {
      $rootScope.$apply(function() {
        if (!isNotificationCenterOpen()) {
          displayNotificationCenter();
        }
      });
    };
  })(toastr);

  /**
   * Display a new toast.
   *
   * @param notification atex.dam.Notification the notification to display the toast for
   * @param onClickFn Function the on click callback for the toast
   *
   * @returns the created Toastr element, or undefined if Toastr is not present
   */
  var displayToast = function(notification, onClickFn) {
    if (typeof toastr === 'undefined' || typeof toastr[notification.type] === 'undefined') {
      console.log(notification.type.toUpperCase() + ': ' + notification.message);
    } else {
      var notificationOptions = (notification.persistent === true) ? { timeOut: 0, extendedTimeOut: 0 } : {};

      if (onClickFn !== undefined) {
        notificationOptions.onclick = onClickFn;
      }

      return toastr[notification.type](notification.message, '', notificationOptions);
    }
  };

  /**
   * Clear a specific toast.
   */
  var clearToast = function(toast) {
    toastr.clear(toast);
  };

  /**
   * Clear all currently visible toasts.
   */
  var clearAllToasts = function() {
    toastr.clear();
  };

  /**
   * Returns the complete list of notifications.
   */
  var getNotificationLog = function() {
    return _notificationLog;
  };

  /**
   * Clear the list of notifications.
   */
  var clearNotificationLog = function() {
    _notificationLog = [];
  };

  /**
   * Add a notification to the list of notifications.
   */
  var addNotification = function(notification) {
    _notificationLog = _notificationLog.concat((notification.notifications.length > 0) ? notification.notifications : [notification]);
  };

  /**
   * Returns true if the Notification Center dialog is
   * currently open, else false.
   */
  var isNotificationCenterOpen = function() {
    return $(".notifications-modal").is(":visible");
  };

  /**
   * Display the Notification Center dialog.
   */
  var displayNotificationCenter = function(props) {
    var modalScope = $rootScope.$new(true);

    _.extend(modalScope, props);
    _.extend(modalScope, atex.dam.ViewUtils);

    modalScope.maxItemsShown = 5;

    var modal = $modal({
      show: true,
      scope: modalScope,

      template: 'views/dam-notifications-dialog.html',
      modalClass: 'notifications-modal ng-cloak',
      backdrop: 'static',
      keyboard: false
    });

    var deferred = $q.defer();

    var destroyModal = function() {
      modal.then(function(modalEl) {
        modalEl.on('hidden.bs.modal', function() {
          modalScope.$destroy();
        });

        modalEl.modal('hide');
      });
    };

    modalScope.notificationCount = function() {
      return getNotificationLog().length;
    };

    modalScope.getLatestItems = function() {
      return getNotificationLog().slice(0).reverse().slice(0, modalScope.maxItemsShown);
    };

    modalScope.showMore = function() {
      modalScope.maxItemsShown *= 2;
    };

    modalScope.clearNotificationLog = clearNotificationLog;

    modalScope.doClose = function() {
      destroyModal();
      deferred.resolve();
    };

    return deferred.promise;
  };

  return {
    getNotificationLog: getNotificationLog,
    clearNotificationLog: clearNotificationLog,

    addNotification: function(notification, shouldLog, onClickFn) {
      if (shouldLog === true) {
        addNotification(notification);
      }

      return displayToast(notification, onClickFn);
    },

    clearToast: clearToast,
    clearAllToasts: clearAllToasts,

    isNotificationCenterOpen: isNotificationCenterOpen,
    displayNotificationCenter: displayNotificationCenter
  };
} ]);
